export const THEMES = {
  casino: {
    name: 'Classic Casino',
    variables: {
      '--table-felt': 'radial-gradient(ellipse at center, #1a4d2e 0%, #0f2818 50%, #0a1410 100%)',
      '--table-rail': '#8b6914',
      '--app-bg': '#0d0e14',
      '--surface-card': '#1a1a2e',
      '--surface-overlay': 'rgba(0, 0, 0, 0.85)',
      '--card-back': '#1a3a5c',
      '--card-border': '#555',
      '--card-face': '#fff',
      '--accent-primary': '#d4a843',
      '--accent-primary-dark': '#8b7120',
      '--accent-success': '#34d399',
      '--accent-danger': '#ff6b6b',
      '--accent-nem': '#39ff14',
      '--accent-info': '#60a5fa',
      '--text-primary': '#e2d9c8',
      '--text-secondary': '#8a8070',
      '--text-on-accent': '#0d0e14',
      '--avatar-border': '#d4a843',
      '--avatar-border-dealer': '#ffd700',
      '--sit-out-opacity': '0.4',
      '--roundhouse-glow': '#ff6b00',
      '--score-positive': '#34d399',
      '--score-negative': '#ff6b6b',
      '--score-neutral': '#8a8070',
      '--ready-light': '#34d399',
      '--foul-color': '#ff8c00',
    },
  },
};

export const DEFAULT_THEME = 'casino';
